<template>
  <div>
    <div class="d-flex align-center py-1 bg-gray-200 pl-2">
      <v-icon class="mr-1" size="20">$Cog</v-icon>
      <span class="font-13 font-weight-medium">
        Cobertura por Exceção <v-icon size="15">$CaretRight</v-icon> {{ breadcrumb }}
      </span>
    </div>

    <v-card flat>
      <v-tabs v-model="tab" centered>
        <v-tab class="tab-personalizado">
          <v-icon left size="20">$Filial</v-icon>
          Cobertura por filial
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left size="18">$Grid1x2</v-icon>
          Cobertura por Segmento
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left size="20">$Empresa</v-icon>
          Cobertura por Fornecedor
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left size="20">$Boxes</v-icon>
          Cobertura por Produto
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaGeral />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaPorSegmento />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaPorFornecedor />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaPorProduto />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import CoberturaGeral from "./CoberturaGeral/Index"
import CoberturaPorFornecedor from "./CoberturaPorFornecedor/Index"
import CoberturaPorSegmento from "./CoberturaPorSegmento/Index"
import CoberturaPorProduto from "./CoberturaPorProdutos/Index.vue"

export default {
  name: "CoberturaCompras",
  components: {
    CoberturaGeral,
    CoberturaPorFornecedor,
    CoberturaPorSegmento,
    CoberturaPorProduto
  },
  data() {
    return {
      tab: 0,
      breadcrumbs: [
        "Filial",
        "Segmento",
        "Fornecedor",
        "Produto"
      ]
    }
  },
  computed: {
    breadcrumb() {
      return this.breadcrumbs[this.tab]
    }
  }
}
</script>
